import c from "../common"

export default {
    // Dashboard
    Edit: "修改",
    Description: "簡介",
    VoucherDiscount: c.voucher.chn + " & " + c.discount.chn,
    ParVendor: "參與商戶",
    Overview: "概覽",
    VendorList: "可參與之商戶",
    Remove: "移除",
    ConfirmRemove: "確定移除?",
    
    // Common
    Event: c.event.chn,
    Confirm: c.Confirm.chn,
    Cancel: c.cancel.chn,
    Next: c.next.chn,
    Previous: c.previous.chn,
    NA: c.NA.chn,

    // Status
    Pending: c.Pending.chn,
    OnGoing: c.OnGoing.chn,
    Expired: c.Expired.chn,
    Cancelled: c.Cancelled.chn,
    Participated: "已參與",    
    WaitApprove: c.WaitApprove.chn,
    Rejected: c.Rejected.chn,
    Approved: c.Approved.chn,


    // Message
    Warning1: "請提供名稱",
    Warning2_1: "簡介不可超過 ",
    Warning2_2: " 字",
    Warning3: "請提供完整日期",
    Warning4: "此推廣活動將不可於下列日期創建積分計劃, 因為與現有積分計劃的日期重疊:",
    Warning5: "請提供完整日期",
    Warning6: "如有積分計劃或電子券將會被一併取消",
    Warning7: "如有積分計劃將會被取消",
    Info1: "開始日期最早可於2日後, 結束日期不受限",
    Success1: "成功增加! 請重新加載",
    Success2: "活動已取消!請重新加載",
    Success3: "積分計劃及活動已取消!請重新加載",
    Success4: "成功!請重新加載",
    Success5: "成功修改活動!請重新加載",
    Success6: "成功修改活動，已提交的積分計劃已取消!請重新加載",

    // Step 1
    CreateEvent: "創建新" + c.event.chn,
    Name: "名稱",
    Date: "日期",

    // Step 2
    InviteVendor: "邀請夥伴參加推廣活動",
    ModifyList: c.ModifyPartnersList.chn,
    SelectAll: "選擇全部",
    SendInvite: "發送邀請",

    // Step 3
    Success: "成功創建活動!請重新加載",
    ToVoucher: "前往創建電子劵",
    Skip: "暫時跳過",

    // Edit
    Back: c.Back.chn,
    EditEvent: "修改" + c.event.chn,
    Submit: "提交",
}